<!--
 * @Date: 2020-08-20 11:13:13
 * @Author: lvjun
 * @Description: 初始页面
-->
<template>
  <div id="app">
    <router-view/>
    <SocketMessage></SocketMessage>
    <!-- deepSeek ai助手 浮窗 -->
    <deep-seek-helper v-if="isShowDeepSeekHelper"/>
    <!-- 在线客服组件 -->
    <im-socket v-if="isShowImSocket && extensionNo"/>
  </div>
</template>
<script>
import Vue from 'vue'
import { mapGetters, mapMutations } from 'vuex'
import ShowCenterDialog from '@/components/export-center-dialog/instance'
import ShowCenterDialogNew from '@/components/export-center-dialog-new/instance'
import ShowExportDialog from '@/components/export-dialog/instance'
import DeepSeekHelper from '@/components/base/DeepSeekHelper.vue'
import ImSocket from '@/components/base/ImSocket.vue'
import { cacheHelper } from '@public/utils/cacheHelper'
import { getOutUserByCode } from '@/api'

export default {
  name: 'App',
  data() {
    return {

    }
  },
  computed: {
    ...mapGetters(['token', 'menu', 'user']),
    // 是否展示deepSeek ai助手
    isShowDeepSeekHelper() {
      return this.token && this.menu.some(item => item.url === 'DEEP_SEEK_HELPER')
    },
    // 是否展示ImSocket组件
    isShowImSocket() {
      return this.token && !['Login', 'BindWeChat', 'redirect'].includes(this.$route.name)
    }
  },
  components: {
    DeepSeekHelper,
    ImSocket
  },
  data() {
    return {
      extensionNo: null, // 外部用户信息
    }
  },
  mounted () {
    this.isShowImSocket && this.getOutUserInfo();
    Vue.prototype.$showCenterDialog = ShowCenterDialog().open;
    Vue.prototype.$showCenterDialogNew = ShowCenterDialogNew().open;
    Vue.prototype.$showExportDialog = ShowExportDialog().open
    cacheHelper.getUsage()
  },
  methods: {
    ...mapMutations(['SET_USER_EXTENSION_NO']),
    // 调用获取外部用户信息接口
    async getOutUserInfo() {
      try {
        const res = await getOutUserByCode()
        if (res && res.data && res.data.code && res.data.extensionNo) {
          this.extensionNo = res.data.extensionNo
          if (res.data.extensionNo) {
            this.SET_USER_EXTENSION_NO(res.data.extensionNo)
          }
        }
      } catch (error) {
        console.error('获取外部用户信息失败:', error)
      }
    }
  },
  watch: {
    token(nVal) {
      if (nVal) {
        this.getOutUserInfo()
      }
    },
    user(nVal, oVal) {
      if (nVal) {
        const myDate = new Date();
        const year = myDate.getFullYear();
        const month = myDate.getMonth() + 1;
        const date = myDate.getDate();
        let text = (nVal?.name??oVal?.name) + ' ' + year + '-' + month + '-' + date
        this.watermark({ text })
      }
    }
  }

}
</script>
<style lang="scss">
@import "./assets/iconfont/iconfont.css";
@import "./assets/font/iconfont.css";
$bg: rgba(0, 0, 0, 0.1);
#app{
  height: 100%;
  width: 100%
}
::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}
/*滚动条小方块*/
::-webkit-scrollbar-thumb {
  background-color: $-color-icon-dark-routine;
  -webkit-border-radius: 5px; /* Safari 和 Chrome */
  -moz-border-radius: 5px; /* Firefox */
  -o-border-radius: 5px; /* Opera */
  border-radius: 5px;
}
/*滚动轨道两端按钮*/
::-webkit-scrollbar-button {
  -webkit-box-shadow: inset 0 0 5px $bg;
  background-color: $bg;
}
/*滚动轨道 内阴影*/
::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px $bg;
  background-color: $bg;
}
</style>
